import { ContainerDataStore, Container, ContainerStatus } from '@skinsoft/entity/src/container'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { SearchHeader } from '@skinsoft/search'
import { QueryInput } from '@skinsoft/search/src/query-input'
import { EntityFeaturedList, Featured, FeaturedList, LocalizedString, SearchFeatured } from '@skinsoft/ui'
import { partition } from 'rxjs'
import { map, switchMap, tap, toArray } from 'rxjs/operators'
import Component from 'vue-class-component'
import { toFeatured$ } from '../../serializer/featured'
import { ContainerFeaturedCard } from '../container-featured-card'
import { ContainerSublistStatus } from './container-sublist-status'

require('./container-featured-list.scss')
@Component({
    components: {
        sLocalizedString: LocalizedString,
        sContainerFeaturedCard: ContainerFeaturedCard,
        sContainerSublistStatus: ContainerSublistStatus,
        sQueryInput: QueryInput
    },
    props: ['targetRouteName'],
    template: require('./container-featured-list.html'),
})
export class ContainerFeaturedList extends ReactiveVue {
    public $containerDataStore: ContainerDataStore
    public openContainersStatusList = [ContainerStatus.OPEN, ContainerStatus.NOT_DEFINED]
    public closedContainersStatusList = [ContainerStatus.CLOSED]
    public targetRouteName
    public query: string = ''

    public goToContainer(container: Container) {
        this.$router.push({ name: this.targetRouteName, params: { id: container.id }} as any)
    }
}
